var clearSessionActiveProps = function clearSessionActiveProps() {
  // In some browsers, under some conditions, iterating over sessionStorage keys could cause a SecurityException to be raised.
  try {
    Object.keys(sessionStorage).filter(function (key) {
      return key.startsWith('activeProps_');
    }).forEach(function (key) {
      sessionStorage.removeItem(key);
    });
  } catch (error) {
    console.error(error);
  }
};
export { clearSessionActiveProps };